import React, { useEffect, useRef, useState } from "react";
import classes from "./SwipeGame.module.css"
import { mapValues } from "react-sdk/utils";
import SoundPlayer from "react-sdk/SoundPlayer";
import clsx from "clsx";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { observer } from "mobx-react-lite";
import SwipeRecap from "./SwipeRecap";
import Media from "../Media/Media";

const SwipeProposition = ({ proposition, onFinished }) => {

  const [angle, setAngle] = useState(0);
  const [pos, setPos] = useState(0);

  const [active, setActive] = useState(false);

  const answered = proposition?.userAnswer !== null

  const textThreshold = 75 // moment ou on affiche le choix au lieu des fleches
  const answerThreshold = 400


  useEffect(() => {
    setAngle(0)
    setPos(0)

  }, [proposition]);

  useEffect(() => {
    if (answered) {
      window.removeEventListener("mouseup", handleMouseUp)
      window.removeEventListener("mousemove", handleMouseMove)
      window.removeEventListener("touchmove", handleTouchMove)
      window.removeEventListener("touchend", handleMouseUp)
    }
  }, [answered]);

  let style = {
    transform: `rotateZ(${angle}deg) translateX(${pos}px)`,
    opacity: Math.max(1 - (Math.abs(pos) / 550) ** 8, 0.4)
  }


  useEffect(() => {
    if (Math.abs(pos) > answerThreshold && active) {
      handleAnswer()
    }
  }, [pos])

  useEffect(() => {
    if (active) {
      window.addEventListener("mousemove", handleMouseMove)
      window.addEventListener("mouseup", handleMouseUp)

      window.addEventListener("touchmove", handleTouchMove)
      window.addEventListener("touchend", handleMouseUp)
    }
    return () => {
      window.removeEventListener("mouseup", handleMouseUp)
      window.removeEventListener("mousemove", handleMouseMove)
      window.removeEventListener("touchmove", handleTouchMove)
      window.removeEventListener("touchend", handleMouseUp)
    }
  }, [active, angle]);

  function calulateAngle(x) {
    let angle = mapValues(x, 0, window.innerWidth, -4, 4, true)
    return angle
  }

  function calculateXPos(x) {
    let posX = pos + x
    return posX
  }


  function handleMouseDown(e) {
    SoundPlayer.playSound("click")
    if (answered) return
    if (pos !== 0) return
    setActive(true)
  }
  function handleMouseMove(e) {
    if (!active) return
    if (answered) return
    setAngle(calulateAngle(e.clientX))
    setPos(calculateXPos(e.movementX))
  }
  function handleTouchMove(e) {
    if (!active) return
    if (answered) return
    let x = e?.touches[0]?.clientX
    if (x) {
      setPos(calculateXPos(x))
      setAngle(calulateAngle(x))
    }
  }

  function handleMouseUp(e) {
    if (!active) return

    setAngle(0)
    setPos(0)
    SoundPlayer.playSound("click")

    setActive(false)
  }

  function handleAnswer() {
    setActive(false)

    let value = pos < 0 ? false : true

    const speed = 500
    let int = setInterval(() => {
      setPos(pos => pos + (value ? -1 * speed : speed))
    }, 50)

    setTimeout(() => {

      clearInterval(int)

      proposition.answer(value)


      // setAngle(0)
      // setPos(0)

      onFinished()
    }, 450)
  }

  // let answerOpacity = mapValues(Math.abs(angle), 5, 2.5, 0.5, 0.99, true)

  return (
    <div className={classes.card_ctnr} key={proposition.ID}>
      <div

        className={clsx(classes.card, active && classes.dragging)}
        style={style}
        onMouseEnter={e => SoundPlayer.playSound("rollover")}
        onMouseDown={handleMouseDown}
        onTouchStart={handleMouseDown}
      >
        <div className={classes.card_bg} />
        <div className={classes.card_text}>
          <div dangerouslySetInnerHTML={{ __html: proposition.Text }} />
          {proposition.media && <Media path={proposition.media} />}
        </div>


        {!answered &&
          <div className={classes.answer} >
            {pos > -textThreshold && pos < textThreshold &&
              <>
              <div className={classes.arrows}>
                <FaArrowLeft className={classes.arrow_icon} />
                <FaArrowRight className={classes.arrow_icon} />
              </div>
              <div className={classes.texts}>
                  <div className={clsx(classes.arrow_text, classes.textLeft)} >
                    <div dangerouslySetInnerHTML={{ __html: proposition.incorrectText }} />
                    {proposition.incorrectIcon && <img src={proposition.incorrectIcon} />}
                  </div>
                  <div className={clsx(classes.arrow_text, classes.textRight)} >
                    <div dangerouslySetInnerHTML={{ __html: proposition.correctText }} />
                    {proposition.correctIcon && <img src={proposition.correctIcon} />}
                  </div>
              </div>
              </>}

            {/* {pos <= -textThreshold && <div key={proposition.ID + "_0"} className={classes.future_answer} style={{opacity: answerOpacity}} dangerouslySetInnerHTML={{ __html: proposition.incorrectText }} />} */}
            {pos <= -textThreshold && <div key={proposition.ID + "_0"} className={classes.future_answer} dangerouslySetInnerHTML={{ __html: proposition.incorrectText }} />}

            {/* {pos >= textThreshold && <div key={proposition.ID + "_1"} className={classes.future_answer} style={{opacity: answerOpacity}} dangerouslySetInnerHTML={{ __html: proposition.correctText }} />} */}
            {pos >= textThreshold && <div key={proposition.ID + "_1"} className={classes.future_answer} dangerouslySetInnerHTML={{ __html: proposition.correctText }} />}

          </div>}
      </div>
    </div>
  )
}




const SwipeGame = ({ instance, onDone }) => {
  const [propositionIndex, setPropositionIndex] = useState(0);
  const [style, setStyle] = useState({});
  const ctnrRef = useRef(null)

  useEffect(() => {
    let bb = ctnrRef.current?.getBoundingClientRect()
    if (bb) {
      setStyle({ top: bb.top, position: "absolute" })

    }


  }, []);

  function onPopositionDone() {
    if (propositionIndex < instance.Propositions.length - 1) {
      setPropositionIndex(i => i + 1)
    }
    else {
      onDone()
    }
  }

  return (
    <div className={classes.SwipePropositionsCtnr} ref={ctnrRef}
      style={style}
    >
      <SwipeProposition
        proposition={instance.Propositions[propositionIndex]}
        onFinished={onPopositionDone} />

      <div className={classes.total}>{propositionIndex + 1} / {instance.Propositions.length} </div>

    </div>
  )
}

export default observer(SwipeGame)